import { render, staticRenderFns } from "./AgentChatSupportComponent.vue?vue&type=template&id=752f96d2&scoped=true&"
import script from "./AgentChatSupportComponent.vue?vue&type=script&lang=js&"
export * from "./AgentChatSupportComponent.vue?vue&type=script&lang=js&"
import style0 from "./AgentChatSupportComponent.vue?vue&type=style&index=0&id=752f96d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752f96d2",
  null
  
)

export default component.exports